// import Vue from 'vue'

export default {
    bind: function (el, binding, vnode) {
        // do preparation work
        // e.g. add event listeners or expensive stuff
        // that needs to be run only once
        // `value` is the initial value

        el.addEventListener('click', function (e) {
            e.preventDefault();
            const component = binding.value.hasOwnProperty('component') ? binding.value.component : binding.value;
            const props = binding.value.hasOwnProperty('props') ? binding.value.props : {};
            vnode.context.$modal.openReveal(component, props)
        })
    },
    update: function (value) {
        // do something based on the updated value
        // this will also be called for the initial value
    },
    unbind: function (el, binding, vnode) {
        // do clean up work
        // e.g. remove event listeners added in bind()

        el.removeEventListener('click', function (e) {
            e.preventDefault();
            console.log('open popup', vnode.context.$modal)
            vnode.context.$modal.openReveal(binding.value)
        })
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/directives/OpenInReveal.js